import { CheckRound, Minus, WarningRound } from "@rsuite/icons";
import { useMemo } from "react";

export const BooleanToggleFilterIcon = ({
  filterValue,
  className,
}: {
  filterValue: "true" | "false" | "default";
  className?: string;
}) => {
  const classNames = useMemo(
    () => "rs-table-cell-header-icon-sort" + (className ? " " + className : ""),
    [className]
  );

  if (filterValue === "true") return <CheckRound className={classNames} />;
  else if (filterValue === "false")
    return <WarningRound className={classNames} />;
  else return <Minus className={classNames} />;
};
